import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import css from './SettingsLayoutWrapper.module.css';
import classnames from 'classnames';

import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faWallet,
  faTags,
  faCalendar,
  faPalette,
  faCalendarCheck,
  faComments,
  faAward,
  faGift,
} from '@fortawesome/free-solid-svg-icons';
import { closeNotification, showNotification } from '../../../custom-ducks/utility.duck';
import ReactTooltip from 'react-tooltip';
import { MessageCircle, Lock } from 'react-feather';
import { meetsTierGate, TIERS } from '../../../util/coachTier';

function SettingsLayoutWrapper(props) {
  const { page, children, currentUser } = props;
  const [isSlided, setIsSlided] = useState(false);

  const goToUrl = path => {
    props.history.push(path);
  };

  // Per-tab click handler: navigate to `path` unless the user is
  // already on `pageKey`. Earlier each tab inlined a `page && page !==
  // pageKey && goToUrl(...)` expression — if the `page` prop was ever
  // missing/falsy, the `page &&` short-circuit silently blocked
  // navigation and the tab became un-clickable. This helper drops that
  // guard while keeping the "don't navigate to the page you're already
  // on" behaviour (which avoids redundant history entries).
  const navigateTo = (pageKey, path) => () => {
    if (page !== pageKey) goToUrl(path);
  };

  // const pubData = currentUser && currentUser.attributes.profile.publicData;

  // Tab visibility follows the `page` prop, which the caller (SaaSSettingsPage)
  // already derives from the route rather than the raw isProvider flag — this
  // keeps a participant who has switched into coach view (and lands on
  // /v-coach/settings via the sidebar's coach Settings link) seeing the same
  // coach-only tabs (subscription, payout, branding, verification, referrals)
  // a real coach account would, and keeps a coach browsing the participant
  // "Availability" route (page === 'client_settings') seeing the participant
  // tab set.
  //
  // Exception: /account-settings is shared by both account types, so there the
  // tab set follows the real account type — a participant-only account sees
  // just the Account tab, not the coach tabs — unless they've switched to the
  // coach view from the sidebar (MainDashboardWrapper's per-user activeView).
  const userUuid = currentUser?.id?.uuid;
  let isInCoachView = false;
  if (userUuid && typeof window !== 'undefined') {
    try {
      isInCoachView = window.localStorage.getItem(`viveka_activeView_${userUuid}`) === 'coach';
    } catch (e) {
      // localStorage unavailable — fall back to the account type.
    }
  }
  const isParticipantOnAccountPage =
    page === 'account_settings' &&
    !currentUser?.attributes?.profile?.publicData?.isProvider &&
    !isInCoachView;
  const isProvider = page !== 'client_settings' && !isParticipantOnAccountPage;

  // Wave 1 gates — Coach Branding and Verification are unlocked at
  // the Verified plan tier. Tabs render for every coach but get a
  // lock icon + muted style for Network coaches. Clicking still
  // navigates (so they hit the inline UpgradeGate on the page, which
  // is the actual conversion surface).
  const isVerifiedPlus = meetsTierGate(currentUser, TIERS.VERIFIED);
  // const hasEarlyAccess = currentUser && currentUser.attributes.profile.metadata.hasEarlyAccess;
  // const isInternalUser = currentUser && currentUser.attributes.profile.metadata.isInternalUser;
  // const isVCoachAvailable = isProvider && (hasEarlyAccess || isInternalUser);

  useEffect(() => {
    console.log(window.menuOpenState);
    if (window.menuOpenState) {
      console.log(1);
      document.getElementById('mySidenav').style.width = '200px';
      document.getElementById('mySidenav').style.transition = 'none';
      document.getElementById('mainWrapperDiv').style.transition = 'none';
      document.getElementById('mySidenav').style.left = '0';
    }
  }, [!window.menuOpenState]);

  return (
    <div className={css.wrapper}>
      {/*<h2 className={css.header}>Settings</h2>*/}

      {/*<div className={css.line}></div>*/}
      <div className={css.base}>
        <section className={classnames(css.left)}>
          {isProvider && (
            <div
              onClick={navigateTo('saas_settings', '/v-coach/settings')}
              className={page === 'saas_settings' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faCalendarCheck} />
              <p>Availability</p>
            </div>
          )}

          {/* Participant Availability — calendar connect + weekly availability
              so two-way booking can match the participant's free time. */}
          {!isProvider && !isParticipantOnAccountPage && (
            <div
              onClick={navigateTo('client_settings', '/v-coach/client/settings')}
              className={page === 'client_settings' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faCalendarCheck} />
              <p>Availability</p>
            </div>
          )}

          {/* {isProvider && (
            <div
              onClick={() => page && page !== 'saas_inquiries' && goToUrl('/inbox/sales')}
              className={page && page === 'saas_inquiries' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faComments} />
              <p>Inquiries</p>
            </div>
          )} */}

          {isProvider && (
            <div
              onClick={navigateTo('payments', '/account/payments/pricing')}
              className={page === 'payments' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faUser} />
              <p>Coach subscription</p>
            </div>
          )}

          {isProvider && (
            <div
              onClick={navigateTo('withdrawal', '/account/payments/withdrawal')}
              className={page === 'withdrawal' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faWallet} />
              <p>Payout details</p>
            </div>
          )}

          {page !== 'client_settings' && (
            <div
              onClick={navigateTo('account_settings', '/account-settings')}
              className={page === 'account_settings' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faTags} />
              <p>Account</p>
            </div>
          )}

          {isProvider && (
            <div
              onClick={navigateTo('branding', '/account/branding')}
              className={classnames(
                page === 'branding' ? css.selected : css.nonSelected,
                !isVerifiedPlus && css.locked
              )}
              data-tip={!isVerifiedPlus ? 'Unlocked at Verified' : null}
            >
              <FontAwesomeIcon className={css.icon} icon={faPalette} />
              <p>Coach Branding</p>
              {!isVerifiedPlus && <Lock size={14} className={css.lockIcon} />}
            </div>
          )}

          {/* Verification — testimonials + credentials. Where coaches
              build their public trust signal. Gated to Verified+. */}
          {isProvider && (
            <div
              onClick={navigateTo('verification', '/v-coach/profile/testimonials')}
              className={classnames(
                page === 'verification' ? css.selected : css.nonSelected,
                !isVerifiedPlus && css.locked
              )}
              data-tip={!isVerifiedPlus ? 'Unlocked at Verified' : null}
            >
              <FontAwesomeIcon className={css.icon} icon={faAward} />
              <p>Verification</p>
              {!isVerifiedPlus && <Lock size={14} className={css.lockIcon} />}
            </div>
          )}

          {/* Referrals — refer-a-coach program. Logically setup/profile. */}
          {isProvider && (
            <div
              onClick={navigateTo('referrals', '/referral_program')}
              className={page === 'referrals' ? css.selected : css.nonSelected}
            >
              <FontAwesomeIcon className={css.icon} icon={faGift} />
              <p>Referrals</p>
            </div>
          )}
        </section>
        {/*<div className={css.slideDown} onClick={e => setIsSlided(!isSlided)}>*/}
        {/*  <span></span>*/}
        {/*  <span></span>*/}
        {/*  <span></span>*/}
        {/*</div>*/}
        <section className={css.right}>{children}</section>
      </div>
      <ReactTooltip className={css.tooltip} place={'right'} effect={'solid'} delayHide={10} />
    </div>
  );
}

const mapStateToProps = state => {
  const { currentUserNotificationCount: notificationCount, currentUser } = state.user;
  const { notification } = state.utility;

  return {
    notificationCount,
    currentUser,
    notification,
  };
};

const mapDispatchToProps = dispatch => ({
  notify: data => {
    dispatch(showNotification(data));
  },

  closeNotification: () => {
    dispatch(closeNotification());
  },
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SettingsLayoutWrapper);
